import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../atom/ModalAtom';
import Header2 from '../component/Header2';
import { searchIdRecoil } from '../atom/UserAtom';

const IdSearchResult = () => {
  const [searchId, setSearchId] = useRecoilState(searchIdRecoil);

  return (
    <>
      <Header2 title={'아이디 찾기'} />
      <LS.LoginCntLayout>
        <CS.LoginResultText>
          회원님의 아이디는 “{searchId}” 입니다.
        </CS.LoginResultText>
      </LS.LoginCntLayout>
      <LS.LoginBtnLayout>
        <CS.Btn1Type4 type="button">
          <Link to="/login">로그인</Link>
        </CS.Btn1Type4>
        <CS.Btn1Type1 type="button">
          <Link to="/passwordsearch">비밀번호 찾기</Link>
        </CS.Btn1Type1>
      </LS.LoginBtnLayout>
    </>
  );
};

export default IdSearchResult;
